<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-29 15:05:45
 -->
<template>
  <div :class="this.tag ? 'login-mars-ape-layout-footer' : 'mars-ape-layout-footer'">
    <div class="mars-ape-layout-footer-copyright">
      Copyright <i class="iconfont icon-ic_copyright"></i> 2020 - {{end_year}} {{this.mxDomain.title}}
      <a v-if="mxDomain.beianCode" class="ahref" href="https://beian.miit.gov.cn/">{{mxDomain.beianCode}}</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tag: {
      type: Boolean,
      default: false
    }
  },
  data(){
      let end_year = new Date().getFullYear()
      return {
          end_year
      }
  }
}
</script>

<style lang="stylus" scoped>
.mars-ape-layout-footer,
.login-mars-ape-layout-footer
  font-size 14px
  margin 48px 0 24px
  text-align center
.mars-ape-layout-footer
  color: #606266
.login-mars-ape-layout-footer
  color #fff
  width 100%
  position absolute
  bottom 0
.mars-ape-layout-footer-link
  margin-bottom 8px
.ahref
  color #fff
</style>